import { styled } from '../jss-style';
import buttonStyle from './button';

const useButtonStyle = styled(buttonStyle, 'button');

export { buttonStyle, useButtonStyle };
export default useButtonStyle;
